// 订单类型
export const ORDER_TYPES = {
  // 个人订单
  personal: {
    name: '个人订单',
    value: 10,
  },
  // 企业子订单
  enterprise: {
    name: '企业子订单',
    value: 20,
  },
}

// 订单状态
export const ORDER_STATES = {
  waitBindCar: {
    name: '待绑车',
    value: -1500,
  },
  confirmOrderWaiting: {
    name: '合同待签署',
    value: 0,
  },
  waitingPay: {
    name: '订单待支付',
    value: 1000,
  },
  sendCarCheckoutWaiting: {
    name: '发车待验车',
    value: 1500,
  },
  processing: {
    name: '履约中',
    value: 2500,
  },
  returnCarCheckoutWaiting: {
    name: '退车待验车',
    value: 3500,
  },
  checkoutOrderWaiting: {
    name: '订单待核算',
    value: 4500,
  },
  checkoutExpenseWaiting: {
    name: '费用待结算',
    value: 5000,
  },
  closed: {
    name: '已关闭',
    value: 5500,
  },
}

// 客户类型
export const CUSTOMER_TYPES = {
  personal: {
    name: '个人',
    value: 1,
  },
  enterprise: {
    name: '企业',
    value: 2,
  },
}

// 退车类型
export const RETURN_CAR_TYPES = {
  // 提前解约
  earlyTerminnate: {
    name: '提前解约',
    value: 2,
  },
  // 到期解约
  matureTerminnate: {
    name: '到期解约',
    value: 3,
  },
}

// 退车单状态
export const RETURN_CAR_ORDER_STATES = {
  all: {
    name: '全部',
    value: 0,
  },
  // 已预约
  appointment: {
    name: '已预约',
    value: 50,
  },
  // 待验车
  checkoutCarWaiting: {
    name: '待验车',
    value: 100,
  },
  // 待核算
  checkoutOrderWaiting: {
    name: '待核算',
    value: 200,
  },
  // 待结算
  checkoutExpense: {
    name: '待结算',
    value: 300,
  },
  // 已完成
  returnCarCompleted: {
    name: '已完成',
    value: 400,
  },
  // 已关闭
  returnCarClosed: {
    name: '已关闭',
    value: 500,
  },
}

// 个人还车步骤
export const PERSONAL_RETURN_CAR_STEPS = [
  {
    title: '发起退车',
    icon: '',
    description: '',
  }, {
    title: '入库验车',
    icon: '',
    description: '',
  }, {
    title: '订单核算',
    icon: '',
    description: '',
  }, {
    title: '费用结算',
    icon: '',
    description: '',
  }, {
    title: '退车完成',
    icon: '',
    description: '',
  },
]

// 企业还车步骤
export const ENTERPRISE_RETURN_CAR_STEPS = [
  {
    title: '发起退车',
    icon: '',
    description: '',
  }, {
    title: '入库验车',
    icon: '',
    description: '',
  }, {
    title: '订单核算',
    icon: '',
    description: '',
  }, {
    title: '退车完成',
    icon: '',
    description: '',
  },
]

